import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import VisualizerFilterListItem from '../VisualizerFilterListItem/VisualizerFilterListItem';

import { StyledFilterLabel, StyledFilterList } from './VisualizerFilterListStyles';

var VisualizerFilterList = function VisualizerFilterList(props) {
  return React.createElement(
    Fragment,
    null,
    props.filterType === 'COLOR' && React.createElement(
      StyledFilterLabel,
      null,
      'Filter by Color',
      props.selectedFilter && React.createElement(
        'span',
        null,
        props.selectedFilter
      )
    ),
    React.createElement(
      StyledFilterList,
      { filterType: props.filterType },
      props.filters.map(function (filter) {
        return React.createElement(VisualizerFilterListItem, {
          key: filter,
          filter: filter,
          selectedFilter: props.selectedFilter,
          handleSelectedFilterChange: props.handleSelectedFilterChange,
          filterType: props.filterType,
          categoryTitle: props.categoryTitle
        });
      })
    )
  );
};

VisualizerFilterList.propTypes = {
  handleSelectedFilterChange: PropTypes.func.isRequired,
  filters: PropTypes.array.isRequired,
  selectedFilter: PropTypes.string,
  filterType: PropTypes.oneOf(['SIZE', 'COLOR']),
  categoryTitle: PropTypes.string.isRequired
};

export default VisualizerFilterList;